import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

export default function FloatingNav() {
  const location = useLocation();
  const userData = useSelector((state) => state.account.userData);
  const miniCasinoIframeRef = React.useRef(null);
  const [isCasinoOpen, setIsCasinoOpen] = React.useState(false);

  return (
    <>
      <app-bottom-nav _ngcontent-ng-c1893399002="" _nghost-ng-c2557118667="">
        <nav
          style={{
            zIndex: 500,
          }}
          _ngcontent-ng-c2557118667=""
          className="mobile-footer-menu"
        >
          {isCasinoOpen && (
            <app-mini-casino-iframe
              _ngcontent-ng-c822550196=""
              _nghost-ng-c1599466378=""
              style={{}}
              className="ng-star-inserted"
            >
              <div
                _ngcontent-ng-c1599466378=""
                className="bottom-sheet expanded open over"
              >
                <iframe
                  _ngcontent-ng-c1599466378=""
                  id="miniCasinoIframe"
                  height={220}
                  width="100%"
                  ref={miniCasinoIframeRef}
                  style={{
                    border: "none",
                    zIndex: 1000,
                    pointerEvents: "auto",
                    overflow: "hidden",
                  }}
                  src="https://minicasino.ludoexchange.com/auth/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbmNyeXB0ZWRUb2tlbiI6IlUyRnNkR1ZrWDEvNEFXaWJKeC9DUHVoa1pGUWR5VUFtS3N4NGpRWDdJeG9KU0tSR1Y0OUgxck1TbEJnVTdMalZ5Rzlua3k3UHhlNmo2YkFNZWNSNDF0MW15VVMyVnVIS1laT3ltb0htc1JOSUprVk1VT29jWmhwU2Nmcy9VZm41cTFaWVd3L1RlV00vM0pLZHptVGdTbFFrWUl2ekFMYUlCRW1YWkZVVGZXQUdJb2VFTVBQbDl0Q1RnS3ZtVURTNmNEelVrTDhWZm9qSXdHbTFVNENhMnFFN21mMGs1d0RtT1ZXdmNwMHRiTUdhQzQ2RFVVWjJlWjNwMXE2N01lZjJETlB4Nkt6MXpkNC9sQUJMbFN3cUJRVVVvMlRYaUd6VStJSGxRT2pYZUsvL3FVVGwxUUc1Y0xDeXNNRUIwMkdEYTlWbnlrSk44QjBxbVh6ak0rTGphQT09IiwiaWF0IjoxNzMzNDE5NTkwLCJleHAiOjE3MzM0Mzc1OTB9.aVO2u_uI1Ds2E8TP6_9VPstaoGg6rGJaoVD2yQRBTdU"
                />
              </div>
            </app-mini-casino-iframe>
          )}
          <ul _ngcontent-ng-c2557118667="">
            <li _ngcontent-ng-c2557118667="">
              <a
                _ngcontent-ng-c2557118667=""
                routerlinkactive="active"
                routerlink="/home"
                className="ui-link active-link"
                href="/home"
              >
                <div _ngcontent-ng-c2557118667="">
                  <svg
                    _ngcontent-ng-c2557118667=""
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Capa_1"
                    x="0px"
                    y="0px"
                    width="512px"
                    height="512px"
                    viewBox="0 0 460.298 460.297"
                    xmlSpace="preserve"
                    style={{ enableBackground: "new 0 0 460.298 460.297" }}
                  >
                    <g
                      _ngcontent-ng-c2557118667=""
                      fill="currentColor"
                      transform="matrix(0.989703 0 0 0.989703 2.36984 2.36983)"
                    >
                      <g _ngcontent-ng-c2557118667="">
                        <g _ngcontent-ng-c2557118667="">
                          <path
                            _ngcontent-ng-c2557118667=""
                            d="M230.149,120.939L65.986,256.274c0,0.191-0.048,0.472-0.144,0.855c-0.094,0.38-0.144,0.656-0.144,0.852v137.041    c0,4.948,1.809,9.236,5.426,12.847c3.616,3.613,7.898,5.431,12.847,5.431h109.63V303.664h73.097v109.64h109.629    c4.948,0,9.236-1.814,12.847-5.435c3.617-3.607,5.432-7.898,5.432-12.847V257.981c0-0.76-0.104-1.334-0.288-1.707L230.149,120.939    z"
                            data-original="#000000"
                            data-old_color="#000000"
                            fill="currentColor"
                            className="active-path"
                          />
                          <path
                            _ngcontent-ng-c2557118667=""
                            d="M457.122,225.438L394.6,173.476V56.989c0-2.663-0.856-4.853-2.574-6.567c-1.704-1.712-3.894-2.568-6.563-2.568h-54.816    c-2.666,0-4.855,0.856-6.57,2.568c-1.711,1.714-2.566,3.905-2.566,6.567v55.673l-69.662-58.245    c-6.084-4.949-13.318-7.423-21.694-7.423c-8.375,0-15.608,2.474-21.698,7.423L3.172,225.438c-1.903,1.52-2.946,3.566-3.14,6.136    c-0.193,2.568,0.472,4.811,1.997,6.713l17.701,21.128c1.525,1.712,3.521,2.759,5.996,3.142c2.285,0.192,4.57-0.476,6.855-1.998    L230.149,95.817l197.57,164.741c1.526,1.328,3.521,1.991,5.996,1.991h0.858c2.471-0.376,4.463-1.43,5.996-3.138l17.703-21.125    c1.522-1.906,2.189-4.145,1.991-6.716C460.068,229.007,459.021,226.961,457.122,225.438z"
                            data-original="#000000"
                            data-old_color="#000000"
                            fill=""
                            className="active-path"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>{" "}
                Home{" "}
              </a>
            </li>
            <li _ngcontent-ng-c2557118667="">
              <a
                _ngcontent-ng-c2557118667=""
                routerlinkactive="active"
                routerlink="/inplay"
                className="ui-link"
                href="/inplay"
              >
                <div _ngcontent-ng-c2557118667="" className="icon-inplay">
                  <svg
                    _ngcontent-ng-c2557118667=""
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    viewBox="0 0 129 129"
                    enableBackground="new 0 0 129 129"
                    width="512px"
                    height="512px"
                  >
                    <g _ngcontent-ng-c2557118667="">
                      <g _ngcontent-ng-c2557118667="">
                        <g _ngcontent-ng-c2557118667="">
                          <path
                            _ngcontent-ng-c2557118667=""
                            d="m12.3,70.2c0,28.8 23.4,52.2 52.2,52.2s52.2-23.4 52.2-52.2c0-14.3-5.8-27.4-15.2-36.8l4.1-4.1 1.9,1.9c0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2c1.6-1.6 1.6-4.2 0-5.8l-9.5-9.5c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l1.9,1.9-4.5,4.5c-7.6-5.6-16.7-9.1-26.7-9.9v-3.5h9.1c2.3,0 4.1-1.8 4.1-4.1s-1.8-4.1-4.1-4.1h-27c-2.3,0-4.1,1.8-4.1,4.1s1.8,4.1 4.1,4.1h9.7v3.5c-27,2.1-48.2,24.6-48.2,52zm52.2-44c24.3-3.55271e-15 44.1,19.8 44.1,44.1 0,24.3-19.8,44.1-44.1,44.1-24.3,0-44.1-19.8-44.1-44.1 0-24.4 19.8-44.1 44.1-44.1z"
                            data-original="#000000"
                            data-old_color="#000000"
                            fill="currentColor"
                            className="active-path"
                          />
                          <path
                            _ngcontent-ng-c2557118667=""
                            d="m64.5,73.6h17.5c2.3,0 4.1-1.8 4.1-4.1 0-2.3-1.8-4.1-4.1-4.1h-13.4v-21.1c0-2.3-1.8-4.1-4.1-4.1-2.3,0-4.1,1.8-4.1,4.1v25.3c0,2.2 1.8,4 4.1,4z"
                            data-original="#000000"
                            data-old_color="#000000"
                            fill="currentColor"
                            className="active-path"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>{" "}
                In-Play{" "}
              </a>
            </li>
            <li
              _ngcontent-ng-c2557118667=""
              className="main-nav isNotMarkedSports"
            >
              <a
                _ngcontent-ng-c2557118667=""
                id="bottom-menu-allsports"
                routerlinkactive="active"
                routerlink="/sports"
                className="ui-link"
                href="/sports"
              >
                <div _ngcontent-ng-c2557118667="" className="icon-sports">
                  <svg
                    _ngcontent-ng-c2557118667=""
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 511.999 511.999"
                    xmlSpace="preserve"
                    width="512px"
                    height="512px"
                    style={{ enableBackground: "new 0 0 511.999 511.999" }}
                  >
                    <g _ngcontent-ng-c2557118667="">
                      <g _ngcontent-ng-c2557118667="">
                        <g _ngcontent-ng-c2557118667="">
                          <path
                            _ngcontent-ng-c2557118667=""
                            d="M466.45,49.374c-7.065-8.308-17.368-13.071-28.267-13.071H402.41v-11.19C402.41,11.266,391.143,0,377.297,0H134.705    c-13.848,0-25.112,11.266-25.112,25.112v11.19H73.816c-10.899,0-21.203,4.764-28.267,13.071    c-6.992,8.221-10.014,19.019-8.289,29.624c9.4,57.8,45.775,108.863,97.4,136.872c4.717,11.341,10.059,22.083,16.008,32.091    c19.002,31.975,42.625,54.073,68.627,64.76c2.635,26.644-15.094,51.885-41.794,57.9c-0.057,0.013-0.097,0.033-0.153,0.046    c-5.211,1.245-9.09,5.921-9.09,11.513v54.363h-21.986c-19.602,0-35.549,15.947-35.549,35.549v28.058    c0,6.545,5.305,11.85,11.85,11.85H390.56c6.545,0,11.85-5.305,11.85-11.85v-28.058c0-19.602-15.947-35.549-35.549-35.549h-21.988    V382.18c0-5.603-3.893-10.286-9.118-11.52c-0.049-0.012-0.096-0.028-0.145-0.04c-26.902-6.055-44.664-31.55-41.752-58.394    c25.548-10.86,48.757-32.761,67.479-64.264c5.949-10.009,11.29-20.752,16.008-32.095c51.622-28.01,87.995-79.072,97.395-136.87    C476.465,68.392,473.443,57.595,466.45,49.374z M60.652,75.192c-0.616-3.787,0.431-7.504,2.949-10.466    c2.555-3.004,6.277-4.726,10.214-4.726h35.777v21.802c0,34.186,4.363,67.3,12.632,97.583    C89.728,153.706,67.354,116.403,60.652,75.192z M366.861,460.243c6.534,0,11.85,5.316,11.85,11.85v16.208H134.422v-16.208    c0-6.534,5.316-11.85,11.85-11.85H366.861z M321.173,394.03v42.513H191.96V394.03H321.173z M223.037,370.331    c2.929-3.224,5.607-6.719,8.002-10.46c7.897-12.339,12.042-26.357,12.228-40.674c4.209,0.573,8.457,0.88,12.741,0.88    c4.661,0,9.279-0.358,13.852-1.036c0.27,19.239,7.758,37.45,20.349,51.289H223.037z M378.709,81.803    c0,58.379-13.406,113.089-37.747,154.049c-23.192,39.03-53.364,60.525-84.956,60.525c-31.597,0-61.771-21.494-84.966-60.523    c-24.342-40.961-37.748-95.671-37.748-154.049V25.112c0-0.78,0.634-1.413,1.412-1.413h242.591c0.78,0,1.414,0.634,1.414,1.413    V81.803z M451.348,75.192c-6.702,41.208-29.074,78.51-61.569,104.191c8.268-30.283,12.631-63.395,12.631-97.58V60.001h35.773    c3.938,0,7.66,1.723,10.214,4.726C450.915,67.688,451.963,71.405,451.348,75.192z"
                            data-original="#000000"
                            data-old_color="#000000"
                            fill="currentColor"
                            className="active-path"
                          />
                        </g>
                      </g>
                      <g _ngcontent-ng-c2557118667="">
                        <g _ngcontent-ng-c2557118667="">
                          <path
                            _ngcontent-ng-c2557118667=""
                            d="M327.941,121.658c-1.395-4.288-5.103-7.414-9.566-8.064l-35.758-5.196l-15.991-32.402    c-1.997-4.044-6.116-6.605-10.626-6.605c-4.511,0-8.63,2.561-10.626,6.605l-15.991,32.402l-35.758,5.196    c-4.464,0.648-8.172,3.775-9.566,8.065c-1.393,4.291-0.231,8.999,2.999,12.148l25.875,25.221l-6.109,35.613    c-0.763,4.446,1.064,8.938,4.714,11.59c3.648,2.651,8.487,3,12.479,0.902L256,190.32l31.982,16.813    c1.734,0.911,3.627,1.36,5.512,1.36c2.456,0,4.902-0.763,6.966-2.263c3.65-2.652,5.477-7.144,4.714-11.59l-6.109-35.613    l25.875-25.221C328.172,130.658,329.334,125.949,327.941,121.658z M278.064,146.405c-2.793,2.722-4.068,6.644-3.408,10.489    l3.102,18.09l-16.245-8.541c-1.725-0.908-3.62-1.36-5.514-1.36c-1.894,0-3.788,0.454-5.514,1.36l-16.245,8.541l3.102-18.09    c0.66-3.844-0.615-7.766-3.408-10.489l-13.141-12.81l18.162-2.64c3.859-0.56,7.196-2.985,8.922-6.482l8.123-16.458l8.122,16.458    c1.727,3.497,5.062,5.921,8.922,6.482l18.162,2.64L278.064,146.405z"
                            data-original="#000000"
                            data-old_color="#000000"
                            fill="currentColor"
                            className="active-path"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <span _ngcontent-ng-c2557118667="">Sports</span>
              </a>
            </li>

            <li _ngcontent-ng-c2557118667="">
              <a
                _ngcontent-ng-c2557118667=""
                routerlinkactive="active"
                data-bs-toggle={userData?.token ? "" : "modal"}
                data-bs-target="#ageconfirmationModal"
                className="ui-link"
              >
                <div
                  onClick={(e) => {
                    if (isCasinoOpen) {
                      setIsCasinoOpen(false);
                    } else {
                      setIsCasinoOpen(true);
                    }
                  }}
                  className="icon-pin"
                >
                  <img
                    style={{
                      height: "7.33333vw",
                    }}
                    _ngcontent-ng-c2557118667
                    className="casinoimg"
                    src="/assets/images/chip.gif"
                  />
                </div>{" "}
                Casino{" "}
              </a>
            </li>
            {/**/}
            {/**/}
            <li _ngcontent-ng-c2557118667="">
              <a
                _ngcontent-ng-c2557118667=""
                routerlinkactive="active"
                data-bs-toggle={userData?.token ? "" : "modal"}
                data-bs-target="#ageconfirmationModal"
                className="ui-link"
                href={userData?.token ? "/account" : "#"}
              >
                <div _ngcontent-ng-c2557118667="" className="icon-account">
                  <svg
                    _ngcontent-ng-c2557118667=""
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Capa_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 55 55"
                    xmlSpace="preserve"
                    width="512px"
                    height="512px"
                    style={{ enableBackground: "new 0 0 55 55" }}
                  >
                    <g _ngcontent-ng-c2557118667="">
                      <path
                        _ngcontent-ng-c2557118667=""
                        d="M55,27.5C55,12.337,42.663,0,27.5,0S0,12.337,0,27.5c0,8.009,3.444,15.228,8.926,20.258l-0.026,0.023l0.892,0.752  c0.058,0.049,0.121,0.089,0.179,0.137c0.474,0.393,0.965,0.766,1.465,1.127c0.162,0.117,0.324,0.234,0.489,0.348  c0.534,0.368,1.082,0.717,1.642,1.048c0.122,0.072,0.245,0.142,0.368,0.212c0.613,0.349,1.239,0.678,1.88,0.98  c0.047,0.022,0.095,0.042,0.142,0.064c2.089,0.971,4.319,1.684,6.651,2.105c0.061,0.011,0.122,0.022,0.184,0.033  c0.724,0.125,1.456,0.225,2.197,0.292c0.09,0.008,0.18,0.013,0.271,0.021C25.998,54.961,26.744,55,27.5,55  c0.749,0,1.488-0.039,2.222-0.098c0.093-0.008,0.186-0.013,0.279-0.021c0.735-0.067,1.461-0.164,2.178-0.287  c0.062-0.011,0.125-0.022,0.187-0.034c2.297-0.412,4.495-1.109,6.557-2.055c0.076-0.035,0.153-0.068,0.229-0.104  c0.617-0.29,1.22-0.603,1.811-0.936c0.147-0.083,0.293-0.167,0.439-0.253c0.538-0.317,1.067-0.648,1.581-1  c0.185-0.126,0.366-0.259,0.549-0.391c0.439-0.316,0.87-0.642,1.289-0.983c0.093-0.075,0.193-0.14,0.284-0.217l0.915-0.764  l-0.027-0.023C51.523,42.802,55,35.55,55,27.5z M2,27.5C2,13.439,13.439,2,27.5,2S53,13.439,53,27.5  c0,7.577-3.325,14.389-8.589,19.063c-0.294-0.203-0.59-0.385-0.893-0.537l-8.467-4.233c-0.76-0.38-1.232-1.144-1.232-1.993v-2.957  c0.196-0.242,0.403-0.516,0.617-0.817c1.096-1.548,1.975-3.27,2.616-5.123c1.267-0.602,2.085-1.864,2.085-3.289v-3.545  c0-0.867-0.318-1.708-0.887-2.369v-4.667c0.052-0.52,0.236-3.448-1.883-5.864C34.524,9.065,31.541,8,27.5,8  s-7.024,1.065-8.867,3.168c-2.119,2.416-1.935,5.346-1.883,5.864v4.667c-0.568,0.661-0.887,1.502-0.887,2.369v3.545  c0,1.101,0.494,2.128,1.34,2.821c0.81,3.173,2.477,5.575,3.093,6.389v2.894c0,0.816-0.445,1.566-1.162,1.958l-7.907,4.313  c-0.252,0.137-0.502,0.297-0.752,0.476C5.276,41.792,2,35.022,2,27.5z"
                        data-original="#000000"
                        data-old_color="#000000"
                        fill="currentColor"
                        className="active-path"
                      />
                    </g>
                  </svg>
                </div>{" "}
                Account{" "}
              </a>
              {/**/}
              {/**/}
            </li>
          </ul>
        </nav>
      </app-bottom-nav>
    </>
  );
}
